import {
    SAVE_ALL,
    SET_DOWNLOAD_EVERYTHING,
    SET_RUN_CLIENTS_WITH_LOGGING,
    SET_RUN_CLIENTS_WITH_DX9,
    SET_SHOULD_MINIMIZE_TO_TRAY,
    SET_LANGUAGE,
    SET_TEST_SERVERS,
} from '../data/backend/constants'
import {
    SET_LAUNCH_DELAY,
    SET_AUTO_LAUNCH_ON_LOGIN,
    SET_AUTO_LAUNCH_ON_STARTUP,
    SET_LAYOUT,
} from '../data/ui/constants'
import { getUiSettings, getBackendSettings, getLanguage } from '../selectors'
import { uiSettingsChanged, settingsChanged, languageChanged, setLocale } from '../actions'

function dispatchUiSettingsChanged(store) {
    const uiSettings = getUiSettings(store.getState())
    store.dispatch(uiSettingsChanged(uiSettings))
}

function dispatchChanges(store, prevLocale = '', newLocale = '', fromBackend = false) {
    // Language has changed...
    if (fromBackend || prevLocale !== newLocale) {
        console.info(`locale switched from ${prevLocale} to ${newLocale}`)
        store.dispatch(languageChanged(prevLocale, newLocale))
        store.dispatch(setLocale(newLocale))
    }

    if (!fromBackend) {
        const settings = getBackendSettings(store.getState())
        store.dispatch(settingsChanged(settings))
    }
}

const SettingsMiddleware = store => next => (action) => {
    switch (action.type) {
        case SET_DOWNLOAD_EVERYTHING:
        case SET_RUN_CLIENTS_WITH_LOGGING:
        case SET_RUN_CLIENTS_WITH_DX9:
        case SET_SHOULD_MINIMIZE_TO_TRAY:
        case SET_TEST_SERVERS: {
            // todo: Maybe see if the value has actually changed and only dispatch
            // if so.
            const result = next(action)
            dispatchChanges(store)
            return result
        }

        case SAVE_ALL:
        case SET_LANGUAGE: {
            // First get previous language
            const prevLocale = getLanguage(store.getState())
            const result = next(action)
            // Then the new language
            const newLocale = getLanguage(store.getState())
            dispatchChanges(store, prevLocale, newLocale, action.type === SAVE_ALL)
            return result
        }

        case SET_LAUNCH_DELAY:
        case SET_AUTO_LAUNCH_ON_LOGIN:
        case SET_AUTO_LAUNCH_ON_STARTUP:
        case SET_LAYOUT: {
            // todo: Maybe see if the value has actually changed and only dispatch
            // if so.
            const result = next(action)
            dispatchUiSettingsChanged(store)
            return result
        }

        default:
            return next(action)
    }
}

export default SettingsMiddleware



// WEBPACK FOOTER //
// ./src/features/Settings/middleware/index.js